import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
//import { useAuthStore } from "../../../store/store";

import "../daterangepicker.css";
import "../Usuarios/usuarios.css";
import "../../Forms.css";

import * as api from "helper/helper";
import { Sections } from "../../data/navItem";
import { PermissionsForSection } from "../auth";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { getMonthNames, getYearsUntilNow } from "helper/tools";
import { useAuthStore } from "../../../../store/store";
import TendeciasEfectividadKPITableSmall from "./TendeciasEfectividadKPITableSmall";

export default function TendeciasEfectividadTable() {
  const createClientesRef = useRef();

  const dateRangeRef = useRef();
  const dateRangeEleRef = useRef();

  const yearSelectRef = useRef();

  const reporteSmallRef = useRef();
  const monthSelectRef = useRef();

  const [years, setYears] = useState([]);
  const [yearSelected, setYearSelected] = useState(null);
  const [monthSelected, setMonthSelected] = useState(null);

  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  /** FILTERS */
  const [niveles, setNiveles] = useState([]);

  /** PAGING */
  const selectedDate = useRef(new Date());
  ///start changes CLASS

  useEffect(() => {
    console.log("--->");

    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const daysBack7 = new Date(now);
    daysBack7.setDate(daysBack7.getDate() - 6);
    const daysBack30 = new Date(now);
    daysBack30.setDate(daysBack30.getDate() - 29);

    const thisMonthStart = new Date(now);
    thisMonthStart.setDate(1);
    const thisMonthEnd = new Date(thisMonthStart);
    thisMonthEnd.setMonth(thisMonthEnd.getMonth() + 1);
    thisMonthEnd.setDate(-1);

    const lastMonthStart = new Date(now);
    lastMonthStart.setDate(1);
    lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
    const lastMonthEnd = new Date(lastMonthStart);
    lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1);
    lastMonthEnd.setDate(-1);

    const lastYearStart = new Date(now);
    lastYearStart.setDate(1);
    lastYearStart.setMonth(0);
    lastYearStart.setFullYear(lastYearStart.getFullYear() - 1);

    const lastYearEnd = new Date(lastYearStart);
    lastYearEnd.setFullYear(lastYearStart.getFullYear() + 1);
    lastYearEnd.setDate(-1);

    const sameMonthDifAge = new Date(now);
    sameMonthDifAge.setDate(sameMonthDifAge.getFullYear() - 1);

    dateRangeRef.current = new window.daterangepicker(
      dateRangeEleRef.current,
      {
        locale: {
          customRangeLabel: "Rango Personalizado",
        },
        singleDatePicker: true,
        showDropdowns: true,
        showCustomRangeLabel: true,

        minYear: 2020,
        maxYear: now.getFullYear(), // parseInt(moment().format('YYYY'),10)
        /*  ranges: {
          Hoy: [now, now],
          Ayer: [yesterday, yesterday],
          "Ultimos 7 Dias": [daysBack7, now],
          "Ultimos 30 Dias": [daysBack30, now],
          "Este mes": [thisMonthStart, thisMonthEnd],
          "Ultimo mes": [lastMonthStart, lastMonthEnd],
          "Ultimo Año": [lastYearStart, lastYearEnd],
        },*/
      },
      function (start, end, label) {
        //  var years = 23; //moment().diff(start, 'years');
        const date = start.toDate();
        selectedDate.current = date;
        fetchData();

        //  alert("You are " + years + " years old!");
      },
    );

    /*

    $(function() {

        var start = moment().subtract(29, 'days');
        var end = moment();

        function cb(start, end) {
            $('#reportrange span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
        }

        $('#reportrange').daterangepicker({
            startDate: start,
            endDate: end,
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }
        }, cb);

        cb(start, end);

    });
    
    */
    /*
    .daterangepicker({
      timePicker: true,
      startDate: 22, //moment().startOf("hour"),
      endDate: 33, //moment().startOf("hour").add(32, "hour"),
      locale: {
        format: "M/DD hh:mm A",
      },
    });*/
    const date = new Date();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    setYearSelected(year);
    setMonthSelected(monthIndex);

    //fetchData(monthIndex, date.getFullYear());

    const wideMonthNames = getMonthNames(es).map((month, index) => ({
      name: month,
      isSelected: monthIndex === index,
    }));
    setMonths(wideMonthNames);

    const yearNames = getYearsUntilNow(es).map((year) => ({
      name: year,
      isSelected: false,
    }));
    setYears(yearNames);

    const newPermissions = PermissionsForSection(Sections.Asociados);
    setPermissions(newPermissions);

    let aMode = useAuthStore.getState().clienteDashboadDate;
    fetchData(aMode);

    const clienteDashboadDateHandle = useAuthStore.subscribe(
      (state) => state.productoDashboadDate,
      (value, prevValue) => {
        //  if (value && prevValue === false) {
        // TODO fix  setFireLogout(true);
        /*  setTimeout(() => {
                  userLogout();
                }, 100);
        
                
                useAuthStore.setState({ inLogoutMode: false });*/
        fetchData(value);
        //}
      },
    );

    return () => {
      clienteDashboadDateHandle();
    };
  }, []);

  const fetchData = async (date) => {
    if (date == null) {
      console.log(
        "-->date to fetch is null. Ignoring Fetch_ ProductosNuevosSmall",
      );
      return;
    }
    setIsLoading(true);

    const payload = {
      fechaCreacion: date,
      sortAsc: true,
      top: 10,
    };
    const responseNiveles = await api
      .VentasPorProducto(payload)
      .catch((error) => {
        toast.error("Error al pedir Ventas Productos.");
        setIsLoading(false);
      });

    if (!responseNiveles) {
      setIsLoading(false);
      return;
    }

    setNiveles(responseNiveles.data);
    setIsLoading(false);
  };

  function loadItem(item) {
    if (!permissions.canVerDetalle) return;

    console.log(createClientesRef);
    setModalData(item);

    createClientesRef.current.toggleModal();
  }

  const [months, setMonths] = useState([]);

  /**
   * Search handler
   */

  return (
    <>
      <div className="">
        <div className="bd-example-row1">
          <div className="row">
            <div className="p-3 border bg-primary text-light report-card-title">
              <span>
                TENDENCIAS DE EFECTIVIDAD
                <small className="text-muted"></small>
              </span>
            </div>
          </div>

          <div className="row">
            <TendeciasEfectividadKPITableSmall
              items={niveles}
              openItem={loadItem}
              isLoading={isLoading}
            />
          </div>
        </div>
        <div className="container  overflow-hidden"></div>
      </div>
    </>
  );
}
